import OverlayLoading from "../shared/components/OverlayLoading";
import UploadHeaderCard from "../features/carrier-difot/components/UploadHeaderCard";
import UploadedFilesList from "../features/carrier-difot/components/UploadedFilesList";
import AutomationSummary from "../features/carrier-difot/components/AutomationSummary";
import ProcessedFilesList from "../features/carrier-difot/components/ProcessedFilesList";
import CleanedPreviewTable from "../features/carrier-difot/components/CleanedPreviewTable";
import useCarrierDifotUpload from "../features/carrier-difot/hooks/useCarrierDifotUpload";
import { exportCarrierResults } from "../features/carrier-difot";

export default function CarrierDifotIntegration() {
  const {
    uploadedFiles,
    processedFiles,
    processedRecords,
    isProcessing,
    isSaving,
    dropzone,
    updateFileCarrier,
    removeFile,
    clearFiles,
    saveToSnowflake,
    summary,
    difotPct,
    difotColors,
    previewRows,
  } = useCarrierDifotUpload();

  return (
    <>
      {(isProcessing || isSaving) && (
        <OverlayLoading
          isVisible={isProcessing || isSaving}
          message={
            isSaving
              ? "Saving carrier data to Snowflake..."
              : "Running carrier automation logic..."
          }
          icon="truck"
        />
      )}

      <div className="min-h-[calc(100vh-4rem)] px-4 sm:px-6 py-6 space-y-5">
        <UploadHeaderCard
          dropzone={dropzone}
          isProcessing={isProcessing}
          isSaving={isSaving}
          uploadedCount={uploadedFiles.length}
          processedRecordCount={processedRecords.length}
          onSave={saveToSnowflake}
          onExport={() => exportCarrierResults(processedRecords)}
          onClear={clearFiles}
        />

        <div className="grid gap-5 lg:grid-cols-[1fr_1.2fr]">
          <UploadedFilesList
            uploadedFiles={uploadedFiles}
            processedFiles={processedFiles}
            onCarrierChange={updateFileCarrier}
            onRemove={removeFile}
          />

          <AutomationSummary
            summary={summary}
            difotPct={difotPct}
            difotColors={difotColors}
            processedRecordCount={processedRecords.length}
            hasProcessedFiles={processedFiles.length > 0}
          />
        </div>

        <ProcessedFilesList processedFiles={processedFiles} />

        <CleanedPreviewTable
          previewRows={previewRows}
          totalRecordCount={processedRecords.length}
        />
      </div>
    </>
  );
}
